<template>
    <div>
        <i-form label-position="top">
            <form-item :label="andamento.descricao || 'Descrição'">
                <vue-editor :editorToolbar="editor" v-model="descricao" placeholder="Descreva..."
                       @input="onChange"></vue-editor>
            </form-item>
            <form-item v-if="andamento.tipo_id == 32" :label="andamento.causa || 'Causas do Bug'">
                <i-select filterable clearable multiple size="large" placeholder="" v-model="causa_bug" @input="onChange">
                    <Option v-for="(item,index) in lista_causas" :value="item.descricao" :key="index">{{ item.descricao }}</Option>
                </i-select>
            </form-item>
            <form-item v-if="andamento.id == 2" label="Erros encontrados">
                <InputNumber :min="0" v-model="erros"></InputNumber>
            </form-item>
            <form-item class="row mb-2" v-if="andamento.sistema_id == 4">
                <span>Houve alteração na Árvore Bitis?</span>
                <vs-switch color="success" v-model="alteracao_arvore" :disabled="node_edited || node === null" @input="onChange"/>
            </form-item>
            <TreeNode v-if="alteracao_arvore && tree_update" :programadores="programadores" :tipos="tipos" v-model="node" :change_by_pgd="change_by_pgd"></TreeNode>
        </i-form>
        <div class="floating-btn">
            <i-button v-show="mostrar_botao" @click="onSave" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
        <Spin size="large" fix v-if="carregar"></Spin>
    </div>
</template>

<script>
    import "vue-multiselect/dist/vue-multiselect.min.css" 
    const {editorToolbar} = require("../../../helpers/utils.js") 
    export default {
        components: {
            Multiselect: () => import("vue-multiselect"),
            VueEditor: () => import("vue2-editor").then(({VueEditor}) => VueEditor),
            TreeNode: () => import("../../../components/tree-node.vue")
        },
        name: "pgd-form-causas",
        props: ["andamento"],
        
        data:() =>({
            lista_causas: [],
            descricao: "",
            causa_bug: [],
            erros:0,
            editor: editorToolbar,
            mostrar_botao:false,
            alteracao_arvore: false,
            node: null,
            programadores: {},
            tipos: {},
            node_edited: false,
            tree_update: true,
            change_by_pgd: true,
            carregar:false
        }),
        methods: {
            async getCausasBug() {
                try {
                    const URI = `parametro/causasBug` 
                    let {data} = await this.$axios.get(URI)

                    this.lista_causas = data 
                } catch (error) {
                    console.warn(error) 
                }
            },
            onChange() {
                this.mostrar_botao=true
            },
            async onSave(){
                if(this.alteracao_arvore){
                   await this.updateNode()
                   this.tree_update=false
                }
                this.$emit("input", {
                    descricao_andamento: this.descricao,
                    causa_bug: this.causa_bug,
                    erros: this.erros,
                    andamento: this.andamento.id
                })
            },
            async getNode (id_node) {
                const {data} = await this.$axios.get(`tree/${id_node}`)
                this.node = data || {}
            },
            async updateNode () {
                this.alteracao_arvore = true
                const id_node = this.node.id
                if (this.node.id == null) {
                    return
                }
                    try {
                    await this.$axios.put(`tree/${id_node}`,this.node)
                    this.$vs.notify({text: "Funcionalidade atualizada com sucesso"})
                    this.node_edited = true
                } catch (Err) {
                    console.log(Err)
                }
            },
        },
        created() {
            this.getCausasBug()
            this.programadores = this.$store.getters['programadores']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }))
            this.tipos = [
                {
                    value: 1,
                    label: 'Módulo'
                },
                {
                    value: 2,
                    label: 'Função'
                },
                {
                    value: 3,
                    label: 'Funcionalidade'
                },
            ] 
            if (this.node == null && this.andamento.funcionalidade != null) {
                this.getNode(this.andamento.funcionalidade)
            }
        },
    } 
</script>
